<template>
  <div class="consulAddDialog">
    <div ref="meetingfrom">
    <div class="basicTitle">天长市农村社区协商办理结果评议单</div>
    <div class="basicSubTitle">社区：{{communityName}}</div>
    <table class="basicTable">
      <tr class="basicTableLeft">
        <th>议题内容</th>
        <th>评议内容</th>
        <th>评议形式</th>
        <th>评议结束</th>
        <th>发布时间</th>
        <th>评议结果运用</th>
        <th>备注</th>
      </tr>
      <tr class="basicTableRight">
        <td class="basicTableRightTd">{{content}}</td>
        <td class="basicTableRightTd">
          <input type="text" style="width:99%;height:99%;border:none;" disabled v-model="pingyiform.commentContent">
        </td>
        <td class="basicTableRightTd">
          <table>
            <tr>
              <th>书面</th>
              <th>微信/QQ</th>
              <th>电话</th>
              <th>会议</th>
              <th>其他</th>
            </tr>
            <tr>
              <td>
                <input name="commentType1" disabled v-model="commentType1" type="checkbox" value="0" />
              </td>
              <td>
                <input name="commentType2" disabled v-model="commentType2" type="checkbox" value="1" />
              </td>
              <td>
                <input name="commentType3" disabled v-model="commentType3" type="checkbox" value="2" />
              </td>
              <td>
                <input name="commentType4" disabled v-model="commentType4" type="checkbox" value="3" />
              </td>
              <td> 
                <input name="commentType5" disabled v-model="commentType5" type="checkbox" value="4" />
              </td>
            </tr>
          </table>
        </td>
        <td class="basicTableRightTd">
          <table>
            <tr>
              <th>同意</th>
              <th>不同意</th>
              <th>同意</th>
              <th>不同意</th>
              <th>同意</th>
              <th>不同意</th>
              <th>同意</th>
              <th>不同意</th>
              <th>同意</th>
              <th>不同意</th>
            </tr>
            <tr>
              <td>
                <input name="smCommentResult" disabled v-model="pingyiform.smCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="smCommentResult" disabled v-model="pingyiform.smCommentResult" type="radio" value="1" />
              </td>
              <td>
                <input name="wechatCommentResult" disabled v-model="pingyiform.wechatCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="wechatCommentResult" disabled v-model="pingyiform.wechatCommentResult" type="radio" value="1" />
              </td>
              <td>
                <input name="phoneCommentResult" disabled v-model="pingyiform.phoneCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="phoneCommentResult" disabled v-model="pingyiform.phoneCommentResult" type="radio" value="1" />
              </td>
              <td>
                <input name="meetingCommentResult" disabled v-model="pingyiform.meetingCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="meetingCommentResult" disabled v-model="pingyiform.meetingCommentResult" type="radio" value="1" />
              </td>
              <td>
                <input name="qtCommentResult" disabled v-model="pingyiform.qtCommentResult" type="radio" value="0" />
              </td>
              <td>
                <input name="qtCommentResult" disabled v-model="pingyiform.qtCommentResult" type="radio" value="1" />
              </td>
            </tr>
          </table>
        </td>
        <td class="basicTableRightTdFive">
          <table>
            <tr>
              <th>
                <el-date-picker
                  disabled
                  v-model="pingyiform.publishTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </th>
              <th>汇总时间</th>
              <th>
                <el-date-picker
                  disabled
                  v-model="pingyiform.summaryTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </th>
            </tr>
          </table>
        </td>
        <td class="basicTableRightTdSix">
            <table>
            <tr>
              <th>
                <div class="eleinput">{{pingyiform.commentResult}}</div>
                <!-- <el-input class="eleinput" type="textarea" name="commentResult" placeholder="请输入内容" v-model="pingyiform.commentResult"></el-input> -->
                <!-- <input class="eleinput" type="textarea" name="commentResult" disabled v-model="pingyiform.commentResult"> -->
              </th>
              <th>评议比例分析</th>
              <th>
                <div class="eleinput">{{pingyiform.commentProportion}}</div>
                <!-- <el-input class="eleinput" type="textarea" name="commentProportion" placeholder="请输入内容" v-model="pingyiform.commentProportion"></el-input> -->
                <!-- <input class="eleinput" type="textarea" name="commentProportion" disabled v-model="pingyiform.commentProportion"> -->
              </th>
            </tr>
          </table>
        </td>
        <td class="basicTableRightTd">
          <input type="textarea" v-model="pingyiform.remarks" disabled style="width:99%;height:99%;border:none;">
        </td>
      </tr>
    </table>
    <div class="pingYiRen">评议人或汇总人：<input type="text" disabled v-model="pingyiform.commentPerson" style="width:99%;height:50px;border:none;" placeholder="请输入..."></div>
    </div>
    <div class="boontbtn">
      <el-button type="primary" @click="dayin">打印</el-button>
      <!-- <el-button type="primary" @click="onSave">确认</el-button> -->
      <el-button type="info" @click="quxiao">取消</el-button>
    </div>
  </div>
</template>

<script>
import { post } from "@/api/requrestHttp";
export default {
  props: ["ytid"],
  data() {
    return {
      id: this.ytid,
      consultName: '',
      content: '',
      communityName: "",
      value1: '',
      value2: '',
      commentType1: '',
      commentType2: '',
      commentType3: '',
      commentType4: '',
      commentType5: '',
      pingyiform: {
        commentType: ""
      },
      commentTypeList: []
    };
  },
  methods: {
    getFindConsultById() {
      post("/admin/consult/info/findConsultById",{
        id: this.ytid
      }).then(res => {
        console.log(res)
        this.consultName = res.content.consultName;
        this.content = res.content.content;
        console.log(res.content.communityId)
        if(res.content.communityId == '2') {
          this.communityName = '浔河社区'
        }else if(res.content.communityId == '20') {
          this.communityName = '石街社区'
        }
      })
    },
    getConsultComment() {
      post("/admin/consultComment/info/getConsultComment",{
        consultId: this.ytid
      }).then(res => {
        console.log(res)
        this.commentContent = res.content.commentContent;
        console.log(res.content.commentContent)
        this.pingyiform = res.content;
        console.log(this.pingyiform.commentType)
        this.commentTypeList = this.pingyiform.commentType.split(',');
        console.log(111,this.commentTypeList)
        let index1 = this.commentTypeList.indexOf('0');
        let index2 = this.commentTypeList.indexOf('1');
        let index3 = this.commentTypeList.indexOf('2');
        let index4 = this.commentTypeList.indexOf('3');
        let index5 = this.commentTypeList.indexOf('4');
        console.log('indexlist',index1,index2,index3,index4,index5); 
        if(index1 != '-1') {
          console.log('index0',index1,this.commentType1);
          this.commentType1 = true; 
        }
        if(index2 != '-1') {
          console.log('index1',index2,this.commentType2);
          this.commentType2 = true; 
        }
        if(index3 != '-1') {
          console.log('index2',index3,this.commentType3);
          this.commentType3 = true; 
        }
        if(index4 != '-1') {
          console.log('index3',index4,this.commentType4);
          this.commentType4 = true; 
        }
        if(index5 != '-1') {
          console.log('index4',index5,this.commentType5);
          this.commentType5 = true;
        }
      }).catch(() => {});
    },
    onSave() {
      if(this.commentType1 == true) {
        this.commentTypeList.push(0)
      }
      if(this.commentType2 == true) {
        this.commentTypeList.push(1)
      }
      if(this.commentType3 == true) {
        this.commentTypeList.push(2)
      }
      if(this.commentType4 == true) {
        this.commentTypeList.push(3)
      }
      if(this.commentType5 == true) {
        this.commentTypeList.push(4)
      }
      this.pingyiform.commentType = this.commentTypeList + '';
      post("/admin/consultComment/info/updateConsultComment",{
        ...this.pingyiform,
        consultId: this.id
      }).then(res => {
        console.log(res.content)
        if(res.content == 0) {
            this.$message({
              message: "请先进行评议汇总!!!",
              type:"warning"
        });
        }else {
          
        }
        this.$emit("close")
      })
    },
    getData(){
      console.log(66666);
      this.pingyiform = {}; 
      this.commentTypeList = [];
      this.commentType1= '';
      this.commentType2= '';
      this.commentType3= '';
      this.commentType4= '';
      this.commentType5= '';
      this.content = '';
    },
    quxiao() {
       this.$emit("close")
    },
    dayin() {
      this.$print(this.$refs.meetingfrom)
    }
  },
  mounted() {
    this.getFindConsultById();
    this.getConsultComment();
  }
};
</script>

<style lang="less" scoped>
.consulAddDialog {
  margin: 40px;
  .el-form-item {
    margin-bottom: 10px;
    .el-form-item__error {
      top: 85%;
    }
  }
}
.basicTitle {
  font-size: 25px;
  text-align: center;
}
.basicSubTitle {
  font-size: 22px;
  margin-bottom: 20px;
}
.queRenBtn {
  margin: 60px 0;
}
.basicTable {
  // display: flex;
  // flex-direction: row;
  border-right: 1px solid #804040;
  border-bottom: 1px solid #804040;
  border-collapse: collapse;
  width:100%;
}
// .basicTable tr:nth-child(1) {
//   width: 15%;
// }
// .basicTable tr:nth-child(2) {
//   width: 85%;
// }
.basicTable tr th {
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #804040;
  border-top: 1px solid #804040;
}
.basicTable tr th:nth-child(6) {
  height: 400px;
}
.basicTable tr td:nth-child(6) {
  height: 403px;
}
.basicTable tr td {
  height: 63px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #804040;
  border-top: 1px solid #804040;
}
.basicTableLeft{
  display: inline-block;
    width: 87px;
    // background: red;
}
.basicTableRight {
  display: inline-block;
    // background: green;
    width: calc(100% - 87px);
}
.basicTableRightTd {
  display: flex;
}
.basicTableRightTd table {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.basicTableRightTd {
  display: flex;
  flex-direction: row;
  height: 30px;
  flex: 1;
  box-sizing: border-box;
}
.basicTableRightTd tr {
  display: flex;
  margin-left: -1px;
}
.basicTableRightTd th {
  height: 28px !important;
  flex: 1;
  border-top: none !important;
}
.basicTableRightTd td {
  height: 28px !important;
  flex: 1;
  border: none;
}
.basicTableRightTd tr th:first-child {
  border-left: none !important;
}
.basicTableRightTd tr td:first-child {
  border-left: none !important;
}
.basicTableRightTdFive {
  display: flex;
}
.basicTableRightTdFive table {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.basicTableRightTdFive {
  display: flex;
  flex-direction: row;
  height: 30px;
  flex: 1;
  box-sizing: border-box;
}
.basicTableRightTdFive tr {
  display: flex;
  margin-left: -1px;
}
.basicTableRightTdFive th {
  height: 61px !important;
  flex: 1;
  border-top: none !important;
}
.basicTableRightTdFive th:nth-child(2) {
  width: 61px !important;
}
.basicTableRightTdFive tr th:first-child {
  border-left: none !important;
}
.basicTableRightTdFive tr td:first-child {
  border-left: none !important;
}
.basicTableRightTdSix {
  display: flex;
}
.basicTableRightTdSix table {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.basicTableRightTdSix {
  display: flex;
  flex-direction: row;
  height: 30px;
  flex: 1;
  box-sizing: border-box;
}
.basicTableRightTdSix tr {
  display: flex;
  margin-left: -1px;
}
.basicTableRightTdSix th {
  height: 401px !important;
  flex: 1;
  border-top: none !important;
}
.basicTableRightTdSix th:nth-child(2) {
  width: 61px !important;
}
.basicTableRightTdSix tr th:first-child {
  border-left: none !important;
}
.basicTableRightTdSix tr td:first-child {
  border-left: none !important;
}
.pingYiRen {
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 15px;
}
.boontbtn {
  margin-top: 30px;
  display: flex;
  justify-content: center;
}

</style>
<style lang="less">
.consulAddDialog .eleinput{
  width: 90%;
  height: 90%;
  background-color: #fff;
  border: none;
  textarea{ 
    border:none;
    height: 350px;
    resize: none;
  }
}
.hide {
  /deep/.el-upload--picture-card {
    display: none;
  }
}
</style>